module.exports = __webpack_public_path__ + "static/media/Avatar_10.9d826583.svg";